import { DateTime } from "luxon"

function createAbsence(absenceFromDB, calendarInterval, dayWidth) {
  const startDate = DateTime.fromISO(absenceFromDB.startDate)
  const offsetInDays = startDate.diff(calendarInterval.start, "days").as("days")
  const offsetMargin = offsetInDays * dayWidth
  return { ...absenceFromDB, offsetMargin, startDate, offsetInDays }
}

export function createAbsences(absencesFromDB, calendarInterval, dayWidth) {
  let absenceGroupedByOffsetMargin = []
  let absenceWeeks = []

  absencesFromDB.forEach((absenceFromDB) => {
    const absence = createAbsence(absenceFromDB, calendarInterval, dayWidth)
    absenceGroupedByOffsetMargin[absence.offsetMargin] = absence

    let index = absence.startDate.year + "" + absence.startDate.weekNumber
    if (absenceWeeks[index]) {
      // A week is only approved if all absences within it are approved.
      absenceWeeks[index].approved =
        absenceWeeks[index].approved && absence.approved
    } else {
      const weekOffset = absence.startDate
        .startOf("week")
        .diff(calendarInterval.start, "days")
        .as("days")
      const offsetMargin = weekOffset * dayWidth

      absenceWeeks[index] ||= { offsetMargin, approved: absence.approved }
    }
  })

  return { absenceGroupedByOffsetMargin, absenceWeeks }
}
